/**
 * useOrgRequestDetail hook
 *
 * Fetches a single org-scoped request by ID from /api/tenant/requests.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useApiQuery } from "@/hooks/useApiQuery";
import type { ResponsibleMember } from "@/lib/projects/types";
import type { RequestNeed } from "@/lib/requests/needs";
import type { Request } from "@/lib/requests/types";
interface OrgRequestDetail {
  id: string;
  /** The concurrency token a command on this request is sent against. */
  revision: number;
  status: Request["status"];
  statement_superseded_at: Request["statement_superseded_at"];
  /** The customer's statement of their needs; an organization's own request has none. */
  axis_hints?: Request["axis_hints"];
  bundesland: string | null;
  landkreis: string | null;
  plz: string | null;
  /** What the request needs: its lines, each in its own unit (lib/requests/needs.ts). */
  lines: RequestNeed[];
  organization_id: string | null;
  description: string | null;
  timing_urgency: string | null;
  timing_needed_by: string | null;
  naturraum_id: string | null;
  kompensationsraum_id: string | null;
  created_at: string;
  updated_at: string;
  naturraum: {
    id: string;
    zone_code: string;
    name: string;
  } | null;
  /** Live-derived from the request's project (Pill γ / 869dj704f). */
  responsible_members: ResponsibleMember[];
}
export function useOrgRequestDetail(id) {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      errorMessage: "Anfrage konnte nicht geladen werden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useApiQuery(id ? `/api/tenant/requests/${id}` : null, t0);
}